module.exports = __webpack_public_path__ + "img/teste-auto-explicate.26017ade.webp";